/* 🌈 Color Scales — Dark */
export const dark = {
  cantaloupe1: '#440906FF',
  cantaloupe2: '#7E1810FF',
  cantaloupe3: '#9C1A10FF',
  cantaloupe4: '#C51F09FF',
  cantaloupe5: '#ED2F09FF',
  cantaloupe6: '#FC4913FF',
  cantaloupe7: '#FE6F39FF',
  cantaloupe8: '#FF9B69FF',
  cantaloupe9: '#FFC8A9FF',
  cantaloupe10: '#FFE5D4FF',
  cantaloupe11: '#FFECE0FF',
  cantaloupe12: '#FFF4EDFF',

  shark1: '#101114FF',
  shark2: '#17191CFF',
  shark3: '#1C1E21FF',
  shark4: '#23252AFF',
  shark5: '#2E3136FF',
  shark6: '#363A3FFF',
  shark7: '#44474DFF',
  shark8: '#5D6166FF',
  shark9: '#6A6E74FF',
  shark10: '#787B81FF',
  shark11: '#B0B4BAFF',
  shark12: '#ECEEF1FF',

  sharkAlpha1: '#101114FF',
  sharkAlpha2: '#D8F4F609',
  sharkAlpha3: '#DDEAF814',
  sharkAlpha4: '#D3EDF81D',
  sharkAlpha5: '#D9EDFE25',
  sharkAlpha6: '#D6EBFD30',
  sharkAlpha7: '#D9EDFF40',
  sharkAlpha8: '#D9EDFF5D',
  sharkAlpha9: '#DFEBFD6D',
  sharkAlpha10: ' #E5EDFD7B',
  sharkAlpha11: ' #F1F7FEB5',
  sharkAlpha12: ' #FCFDFFEF',

  // tomato1: '#181111FF',
  // tomato2: '#1F1513FF',
  // tomato3: '#391714FF',
  // tomato4: '#4E1511FF',
  // tomato5: '#5E1C16FF',
  // tomato6: '#6E2920FF',
  // tomato7: '#853A2DFF',
  // tomato8: '#AC4D39FF',
  // tomato9: '#E54D2EFF',
  // tomato10: '#EC6142FF',
  // tomato11: '#FF977DFF',
  // tomato12: '#FBD3CBFF',

  red1: '#191111FF',
  red2: '#201314FF',
  red3: '#3B1219FF',
  red4: '#500F1CFF',
  red5: '#611623FF',
  red6: '#72232DFF',
  red7: '#8C333AFF',
  red8: '#B54548FF',
  red9: '#E5484DFF',
  red10: '#EC5D5EFF',
  red11: '#FF9592FF',
  red12: '#FFD1D9FF',

  // ruby1: '#191113FF',
  // ruby2: '#1E1517FF',
  // ruby3: '#3A141EFF',
  // ruby4: '#4E1325FF',
  // ruby5: '#5E1A2EFF',
  // ruby6: '#6F2539FF',
  // ruby7: '#883447FF',
  // ruby8: '#B3445AFF',
  // ruby9: '#E54666FF',
  // ruby10: '#EC5A72FF',
  // ruby11: '#FF949DFF',
  // ruby12: '#FED2E1FF',

  // crimson1: '#191114FF',
  // crimson2: '#201318FF',
  // crimson3: '#381525FF',
  // crimson4: '#4D122FFF',
  // crimson5: '#5C1839FF',
  // crimson6: '#6D2545FF',
  // crimson7: '#873356FF',
  // crimson8: '#B0436EFF',
  // crimson9: '#E93D82FF',
  // crimson10: '#EE518AFF',
  // crimson11: '#FF92ADFF',
  // crimson12: '#FDD3E8FF',

  // pink1: '#191117FF',
  // pink2: '#21121DFF',
  // pink3: '#37172FFF',
  // pink4: '#4B143DFF',
  // pink5: '#591C47FF',
  // pink6: '#692955FF',
  // pink7: '#833869FF',
  // pink8: '#A84885FF',
  // pink9: '#D6409FFF',
  // pink10: '#DE51A8FF',
  // pink11: '#FF8DCCFF',
  // pink12: '#FDD1EAFF',

  // plum1: '#181118FF',
  // plum2: '#201320FF',
  // plum3: '#351A35FF',
  // plum4: '#451D47FF',
  // plum5: '#512454FF',
  // plum6: '#5E3061FF',
  // plum7: '#734079FF',
  // plum8: '#92549CFF',
  // plum9: '#AB4ABAFF',
  // plum10: '#B658C4FF',
  // plum11: '#E796F3FF',
  // plum12: '#F4D4F4FF',

  // purple1: '#18111BFF',
  // purple2: '#1E1523FF',
  // purple3: '#301C3BFF',
  // purple4: '#3D224EFF',
  // purple5: '#48295CFF',
  // purple6: '#54346BFF',
  // purple7: '#664282FF',
  // purple8: '#8457AAFF',
  // purple9: '#8E4EC6FF',
  // purple10: '#9A5CD0FF',
  // purple11: '#D19DFFFF',
  // purple12: '#ECD9FAFF',

  violet1: '#14121FFF',
  violet2: '#1B1525FF',
  violet3: '#291F43FF',
  violet4: '#33255BFF',
  violet5: '#3C2E69FF',
  violet6: '#473876FF',
  violet7: '#56468BFF',
  violet8: '#6958ADFF',
  violet9: '#6E56CFFF',
  violet10: '#7D66D9FF',
  violet11: '#BAA7FFFF',
  violet12: '#E2DDFEFF',

  // iris1: '#13131EFF',
  // iris2: '#171625FF',
  // iris3: '#202248FF',
  // iris4: '#262A65FF',
  // iris5: '#303374FF',
  // iris6: '#3D3E82FF',
  // iris7: '#4A4A95FF',
  // iris8: '#5958B1FF',
  // iris9: '#5B5BD6FF',
  // iris10: '#6E6ADEFF',
  // iris11: '#B1A9FFFF',
  // iris12: '#E0DFFEFF',

  // indigo1: '#11131FFF',
  // indigo2: '#141726FF',
  // indigo3: '#182449FF',
  // indigo4: '#1D2E62FF',
  // indigo5: '#253974FF',
  // indigo6: '#304384FF',
  // indigo7: '#3A4F97FF',
  // indigo8: '#435DB1FF',
  // indigo9: '#3E63DDFF',
  // indigo10: '#5472E4FF',
  // indigo11: '#9EB1FFFF',
  // indigo12: '#D6E1FFFF',

  blue1: '#0D1520FF',
  blue2: '#111927FF',
  blue3: '#0D2847FF',
  blue4: '#003362FF',
  blue5: '#004074FF',
  blue6: '#104D87FF',
  blue7: '#205D9EFF',
  blue8: '#2870BDFF',
  blue9: '#0090FFFF',
  blue10: '#3B9EFFFF',
  blue11: '#70B8FFFF',
  blue12: '#C2E6FFFF',

  // cyan1: '#0B161AFF',
  // cyan2: '#101B20FF',
  // cyan3: '#082C36FF',
  // cyan4: '#003848FF',
  // cyan5: '#004558FF',
  // cyan6: '#045468FF',
  // cyan7: '#12677EFF',
  // cyan8: '#11809CFF',
  // cyan9: '#00A2C7FF',
  // cyan10: '#23AFD0FF',
  // cyan11: '#4CCCE6FF',
  // cyan12: '#B6ECF7FF',

  // teal1: '#0D1514FF',
  // teal2: '#111C1BFF',
  // teal3: '#0D2D2AFF',
  // teal4: '#023B37FF',
  // teal5: '#084843FF',
  // teal6: '#145750FF',
  // teal7: '#1C6961FF',
  // teal8: '#207E73FF',
  // teal9: '#12A594FF',
  // teal10: '#0EB39EFF',
  // teal11: '#0BD8B6FF',
  // teal12: '#ADF0DDFF',

  // jade1: '#0D1512FF',
  // jade2: '#121C18FF',
  // jade3: '#0F2E22FF',
  // jade4: '#0B3B2CFF',
  // jade5: '#114837FF',
  // jade6: '#1B5745FF',
  // jade7: '#246854FF',
  // jade8: '#2A7E68FF',
  // jade9: '#29A383FF',
  // jade10: '#27B08BFF',
  // jade11: '#1FD8A4FF',
  // jade12: '#ADF0D4FF',

  green1: '#0E1512FF',
  green2: '#121B17FF',
  green3: '#132D21FF',
  green4: '#113B29FF',
  green5: '#174933FF',
  green6: '#20573EFF',
  green7: '#28684AFF',
  green8: '#2F7C57FF',
  green9: '#30A46CFF',
  green10: '#33B074FF',
  green11: '#3DD68CFF',
  green12: '#B1F1CBFF',

  // grass1: '#0E1511FF',
  // grass2: '#141A15FF',
  // grass3: '#1B2A1EFF',
  // grass4: '#1D3A24FF',
  // grass5: '#25482DFF',
  // grass6: '#2D5736FF',
  // grass7: '#366740FF',
  // grass8: '#3E7949FF',
  // grass9: '#46A758FF',
  // grass10: '#53B365FF',
  // grass11: '#71D083FF',
  // grass12: '#C2F0C2FF',

  // gold1: '#121211FF',
  // gold2: '#1B1A17FF',
  // gold3: '#24231FFF',
  // gold4: '#2D2B26FF',
  // gold5: '#38352EFF',
  // gold6: '#444039FF',
  // gold7: '#544F46FF',
  // gold8: '#696256FF',
  // gold9: '#978365FF',
  // gold10: '#A39073FF',
  // gold11: '#CBB99FFF',
  // gold12: '#E8E2D9FF',

  // bronze1: '#141110FF',
  // bronze2: '#1C1917FF',
  // bronze3: '#262220FF',
  // bronze4: '#302A27FF',
  // bronze5: '#3B3330FF',
  // bronze6: '#493E3AFF',
  // bronze7: '#5A4C47FF',
  // bronze8: '#6F5F58FF',
  // bronze9: '#A18072FF',
  // bronze10: '#AE8C7EFF',
  // bronze11: '#D4B3A5FF',
  // bronze12: '#EDE0D9FF',

  // brown1: '#12110FFF',
  // brown2: '#1C1816FF',
  // brown3: '#28211DFF',
  // brown4: '#322922FF',
  // brown5: '#3E3128FF',
  // brown6: '#4D3C2FFF',
  // brown7: '#614A39FF',
  // brown8: '#7C5F46FF',
  // brown9: '#AD7F58FF',
  // brown10: '#B88C67FF',
  // brown11: '#DBB594FF',
  // brown12: '#F2E1CAFF',

  // orange1: '#17120EFF',
  // orange2: '#1E160FFF',
  // orange3: '#331E0BFF',
  // orange4: '#462100FF',
  // orange5: '#562800FF',
  // orange6: '#66350CFF',
  // orange7: '#7E451DFF',
  // orange8: '#A35829FF',
  // orange9: '#F76B15FF',
  // orange10: '#FF801FFF',
  // orange11: '#FFA057FF',
  // orange12: '#FFE0C2FF',

  amber1: '#16120CFF',
  amber2: '#1D180FFF',
  amber3: '#302008FF',
  amber4: '#3F2700FF',
  amber5: '#4D3000FF',
  amber6: '#5C3D05FF',
  amber7: '#714F19FF',
  amber8: '#8F6424FF',
  amber9: '#FFC53DFF',
  amber10: '#FFD60AFF',
  amber11: '#FFCA16FF',
  amber12: '#FFE7B3FF',

  // yellow1: '#14120BFF',
  // yellow2: '#1B180FFF',
  // yellow3: '#2D2305FF',
  // yellow4: '#362B00FF',
  // yellow5: '#433500FF',
  // yellow6: '#524202FF',
  // yellow7: '#665417FF',
  // yellow8: '#836A21FF',
  // yellow9: '#FFE629FF',
  // yellow10: '#FFFF57FF',
  // yellow11: '#F5E147FF',
  // yellow12: '#F6EEB4FF',

  // lime1: '#11130CFF',
  // lime2: '#151A10FF',
  // lime3: '#1F2917FF',
  // lime4: '#29371DFF',
  // lime5: '#334423FF',
  // lime6: '#3D522AFF',
  // lime7: '#496231FF',
  // lime8: '#577538FF',
  // lime9: '#BDEE63FF',
  // lime10: '#D4FF70FF',
  // lime11: '#BDE56CFF',
  // lime12: '#E3F7BAFF',

  // mint1: '#0E1515FF',
  // mint2: '#0F1B1BFF',
  // mint3: '#092C2BFF',
  // mint4: '#003A38FF',
  // mint5: '#004744FF',
  // mint6: '#105650FF',
  // mint7: '#1E685FFF',
  // mint8: '#277F70FF',
  // mint9: '#86EAD4FF',
  // mint10: '#A8F5E5FF',
  // mint11: '#58D5BAFF',
  // mint12: '#C4F5E1FF',

  // sky1: '#0D141FFF',
  // sky2: '#111A27FF',
  // sky3: '#112840FF',
  // sky4: '#113555FF',
  // sky5: '#154467FF',
  // sky6: '#1B537BFF',
  // sky7: '#1F6692FF',
  // sky8: '#197CAEFF',
  // sky9: '#7CE2FEFF',
  // sky10: '#A8EEFFFF',
  // sky11: '#75C7F0FF',
  // sky12: '#C2F3FFFF',
} as const;
